<div class="container" *ngIf="!isLoading">
    <div class="main">
        <div class="header">
            <h1 class="title">{{ 'integartion.dialog.title' | translate }}</h1>
            <span class="description">
                {{ 'integartion.dialog.description-1' | translate }}<br />
                {{ 'integration.dialog.description-2' | translate }}
            </span>
        </div>
        <mat-radio-group [(ngModel)]="data.integration.type" class="options">
            <div
                class="option-container"
                [class.selected]="data.integration.type === STATUS_COLOR"
                (click)="setIntegrationType(STATUS_COLOR)">
                <div class="option-image-1"></div>
                <div class="option-information">
                    <h2 class="option-name">
                        {{ 'integration.dialog.status-color.type.name' | translate }}
                    </h2>
                    <span class="option-description">{{
                        'integration.dialog.status-color.type.description' | translate
                    }}</span>
                </div>
                <div class="option-select-button">
                    <div class="option-radio-button-wrapper">
                        <mat-radio-button [value]="STATUS_COLOR">{{
                            'integration.dialog.type.radio-button.label' | translate
                        }}</mat-radio-button>
                    </div>
                </div>
            </div>
            <div
                class="option-container"
                [class.selected]="data.integration.type === VISUAL_STATE"
                (click)="setIntegrationType(VISUAL_STATE)">
                <div class="option-image-2"></div>
                <div class="option-information">
                    <h2 class="option-name">
                        {{ 'integration.dialog.visual-state.type.name' | translate }}
                    </h2>
                    <span class="option-description">{{
                        'integration.dialog.visual-state.type.description' | translate
                    }}</span>
                </div>
                <div class="option-select-button">
                    <div class="option-radio-button-wrapper">
                        <mat-radio-button [value]="VISUAL_STATE">{{
                            'integration.dialog.type.radio-button.label' | translate
                        }}</mat-radio-button>
                    </div>
                </div>
            </div>
        </mat-radio-group>
        <div class="option-help-container">
            <div class="option-help-header">
                <h4 class="option-help-title">
                    {{ 'integration.dialog.helper.title' | translate }}
                </h4>
                <div class="add-button" (click)="openHelper()">
                    <mat-icon svgIcon="plus" *ngIf="!isOpenHelper"></mat-icon>
                    <mat-icon svgIcon="minus" *ngIf="isOpenHelper"></mat-icon>
                </div>
            </div>
            <span class="option-help-description" *ngIf="isOpenHelper">
                {{ 'integration.dialog.helper.description' | translate }}
            </span>
        </div>
    </div>
    <div class="footer" [class.editing]="isEditing">
        <div class="delete-button" *ngIf="isEditing" (click)="deleteIntegration()">
            <mat-icon class="close-icon" svgIcon="close"></mat-icon>
            {{ 'integration.settings.status-color.button-text' | translate }}
        </div>
        <div class="button-container">
            <button class="text-button" (click)="close(undefined)">
                {{ 'dlg.cancel' | translate }}
            </button>
            <app-button
                [disable]="isSetupButtonDisabled()"
                text="integartion.dialog.button-text"
                customFontFamily="NotoSans-SemiBold"
                size="small"
                customFontSize="14px"
                (onClick)="setUpIntegrate()"></app-button>
        </div>
    </div>
</div>

<app-loading-spinner
    *ngIf="isLoading"
    class="spinner-component"
    [custom]="true"
    size="80"
    strokeWidth="3"></app-loading-spinner>

<app-confirmation-window
    #deleteDialog
    mainLabel="integration.dialog.delete.title"
    subLabel="integration.dialog.delete.description"
    [goBackLabel]="'dlg.cancel'"
    [saveLabel]="'dlg.confirm'"
    [inverseColors]="true"></app-confirmation-window>
